import { ProductEntity } from "../ProductsAndCatalogItems/ProductEntity"
import { EProductOrderModeType } from "../../Enum/EProductOrderModeType"
import { OrderCatalogProduct } from "./OrderCatalogProduct"

export class OrderProduct extends OrderCatalogProduct {
  productEntityId: number

  productEntity: ProductEntity

  constructor(data: Partial<OrderProduct> = {}) {
    super(data)

    this.productEntityId = data.productEntityId ?? -1

    this.productEntity = new ProductEntity(data.productEntity)
  }

  protected override getJsonFields(): string[] {
    return [...super.getJsonFields(), "productEntityId"]
  }

  needFulfillment(): boolean {
    return this.productEntity.catalogProductEntity.needFulfillment
  }

  getName() {
    return this.productEntity.catalogProductEntity.name
  }

  getImage() {
    return this.productEntity.catalogProductEntity.iconUrl.toClientRequest()
  }

  getProductOrderMode(): EProductOrderModeType {
    return this.productEntity.catalogProductEntity.productOrderMode
  }
}
